import { useState } from 'react';
import { createPortal } from 'react-dom';

import { downloadFileFromUrl } from '../lib/downloadFile';

type AssetModalProps = {
  url: string;
  filename: string;
  onClose: () => void;
};

export function AssetModal({ url, filename, onClose }: AssetModalProps) {
  const [downloading, setDownloading] = useState(false);

  async function handleDownload(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (downloading) return;

    setDownloading(true);
    try {
      await downloadFileFromUrl(url, filename);
    } catch {
      window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
      setDownloading(false);
    }
  }

  return createPortal(
    <div className="asset-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="asset-modal-header"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="asset-modal-filename">{filename}</span>
        <div className="asset-modal-actions">
          <button
            type="button"
            className="asset-modal-download"
            disabled={downloading}
            onClick={(e) => void handleDownload(e)}
          >
            {downloading ? '…' : '↓ Download'}
          </button>
          <button type="button" className="asset-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
      </div>
      <img
        src={url}
        alt={filename}
        className="asset-modal-image"
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body,
  );
}
